/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailySignInResponse } from '../models/DailySignInResponse';
import type { GetPointDetailsResponse } from '../models/GetPointDetailsResponse';
import type { GetSignInRecordsResponse } from '../models/GetSignInRecordsResponse';
import type { RechargeApplyRequest } from '../models/RechargeApplyRequest';
import type { RechargeApplyResponse } from '../models/RechargeApplyResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PointsService {
	/**
	 * @returns GetPointDetailsResponse A successful response.
	 * @throws ApiError
	 */
	public static getPointDetails({
		page,
		pageSize,
		fundType,
		sourceType,
	}: {
		page?: number;
		pageSize?: number;
		fundType?: number;
		sourceType?: number;
	}): CancelablePromise<GetPointDetailsResponse> {
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/points/details',
			query: {
				page: page,
				pageSize: pageSize,
				fundType: fundType,
				sourceType: sourceType,
			},
		});
	}
	/**
	 * @returns RechargeApplyResponse A successful response.
	 * @throws ApiError
	 */
	public static rechargeApply({
		body,
	}: {
		body: RechargeApplyRequest;
	}): CancelablePromise<RechargeApplyResponse> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/points/recharge/apply',
			body: body,
		});
	}
	/**
	 * @returns DailySignInResponse A successful response.
	 * @throws ApiError
	 */
	public static dailySignIn(): CancelablePromise<DailySignInResponse> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/points/signin',
		});
	}
	/**
	 * @returns GetSignInRecordsResponse A successful response.
	 * @throws ApiError
	 */
	public static getSignInRecords({
		page,
		pageSize,
	}: {
		page?: number;
		pageSize?: number;
	}): CancelablePromise<GetSignInRecordsResponse> {
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/points/signin/records',
			query: {
				page: page,
				pageSize: pageSize,
			},
		});
	}
	public static getRechargeRecords(params: any): any {
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/points/recharge/records',
			query: params,
		});
	}
}
